import React, { Component, cloneElement } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { hideModal, resetModal } from 'redux/modules/modal';
import PropTypes from 'prop-types';

const styles = theme => ({
	modal: {},
	content: {},
	actions: {},
	button: {}
});

@withStyles(styles)
class ConfirmYourEmailAddressModal extends Component {

	render() {
		const { classes, modalShown, resetModal, title } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				classes={{
					paper: classes.modal
				}}>
				{title && <DialogTitle>{title}</DialogTitle>}
				{this.renderContent()}
				<DialogActions className={classes.actions}>
					{this.renderButtons()}
				</DialogActions>
			</Dialog>
		);
	}

	renderContent() {
		let contentText;
		const { message, classes } = this.props;

		if (message && message.__html) {
			contentText = <DialogContentText dangerouslySetInnerHTML={message} variant='body1' color='default' />;
		} else {
			contentText = <DialogContentText variant='body1' color='default'>{message}</DialogContentText>;
		}

		return (
			<DialogContent className={classes.content}>
				{contentText}
			</DialogContent>
		);
	}

	renderButtons() {
		const { hideModal, buttons, hideModalOnButtonClick } = this.props;

		return buttons.map((button, index) => {
			return cloneElement(button, {
				key: `set-password-modal-button-${index}`,
				onClick: () => {
					hideModalOnButtonClick && hideModal();
					button.props.onClick && button.props.onClick();
				}
			});
		});
	}
}

ConfirmYourEmailAddressModal.defaultProps = {
	buttons: [],
	hideModalOnButtonClick: true
};

ConfirmYourEmailAddressModal.propTypes = {
	classes: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	title: PropTypes.string,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	buttons: PropTypes.array,
	hideModalOnButtonClick: PropTypes.bool
};

const mapStateToProps = state => ({
	modalShown: state.modal.modalShown
});

const mapDispatchToProps = dispatch => bindActionCreators({
	hideModal,
	resetModal
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfirmYourEmailAddressModal);


// WEBPACK FOOTER //
// ./src/components/Modal/ConfirmYourEmailAddressModal.js